import React, { useState, useRef } from "react";
import { Buffer } from "buffer";
import { ReactComponent as Upload } from "../assets/icons/upload.svg";

export default function ImageUpload({
  label = "Arraste e solte ou selecione um arquivo",
  value,
  onChange,
  acceptSvg = false,
  roundBorder = true,
  tintSvg = null,
  className = "",
  contain = false,
  error = "",
}) {
  const [showInstruction, setShowInstruction] = useState(false);
  const input = useRef();

  const select = () => {
    if (input.current.files.length > 0) {
      var file = input.current.files[0];

      var reader = new FileReader();
      reader.addEventListener("load", function (event) {
        var loadedFile = event.target;
        if (file.type.match("image") && (acceptSvg || !file.type.match("image/svg"))) {
          onChange(loadedFile.result);
        }
      });

      if(acceptSvg){
        reader.readAsText(file);
      } else{
        reader.readAsDataURL(file);
      }
    }
  };

  let previewStyle = {};
  if (value) {
    let finalImg = value;
    if(acceptSvg && !!tintSvg){
      finalImg = finalImg.replaceAll(/stroke="#[(0-9a-fA-F)]+"/g, `stroke="${tintSvg}"`);
      finalImg = finalImg.replaceAll(/fill="#[(0-9a-fA-F)]+"/g, `fill="${tintSvg}"`)
    }
    previewStyle.backgroundImage = acceptSvg ? `url("data:image/svg+xml;base64,${Buffer.from(finalImg).toString("base64")}")` : `url(${finalImg})`;
    previewStyle.backgroundSize = contain ? "contain" : "cover";
    previewStyle.backgroundRepeat = "no-repeat";
    previewStyle.backgroundPosition = "center center";
  }

  return (
    <div>
      <div className="flex items-center">
        <div>
          <div
            style={previewStyle}
            className={`relative flex justify-center items-center w-20 h-20 border-2 border-dashed border-secondary rounded-${roundBorder ? "full" : "sm"} cursor-pointer ${className}`}
            onMouseOver={() => setShowInstruction(true)}
            onMouseOut={() => setShowInstruction(false)}
          >
            <Upload
              className={`h-6 fill-secondary z-60 cursor-pointer ${
                showInstruction ? "opacity-1" : "opacity-0"
              }`}
            />
            <input
              ref={input}
              className="absolute top-0 right-0 w-20 h-20 opacity-0 z-30 cursor-pointer"
              type="file"
              onChange={select}
            />
          </div>
        </div>
        <div className="font-bold text-secondary text-lg px-5">{label}</div>
      </div>
      { !!error && 
        <div className="px-2 bg-validation text-danger rounded-sm">
          {error}
        </div>
      }
    </div>
  );
}
